export class ExcellenceCenter {
    _id: string = '';
    name: string = '';
    sapCode: string = '';
    code: string = '';
    value: number;
    active: boolean
    percentage: number;
    type: number;

    loadFromServer(r: any) {
        if (r._id)
            this._id = r._id;
        if (r.name)
            this.name = r.name;
        if(r.sapCode)
            this.sapCode = r.sapCode
        if(r.code)
            this.code = r.code;
        if(r.value)
            this.value = r.value;
        if(r.percentage)
            this.percentage = r.percentage;
        if(r.type)
            this.type = r.type;
        if (r.active !== undefined)
            this.active = r.active;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/ExcellenceCenter.model.ts